<div class="orders-page">

  <!-- HEADER -->
  <div class="header">

    <h1>📦 {{ t('orderManagement') }}</h1>

    <p>
      {{ t('manageDeliveryWorkflow') }}
    </p>

  </div>

  <!-- SUMMARY -->
  <div class="summary-grid">

    <!-- TOTAL -->
    <div class="summary-card total-card">

      <h3>{{ t('totalOrders') }}</h3>

      <h2>{{ orders.length }}</h2>

      <span>{{ t('allCustomerOrders') }}</span>

    </div>

    <!-- REVENUE -->
    <div class="summary-card revenue-card">

      <h3>{{ t('totalRevenue') }}</h3>

      <h2>৳ {{ totalAmount }}</h2>

      <span>{{ t('completedOrderEarnings') }}</span>

    </div>

    <!-- PROCESSING -->
    <div class="summary-card processing-card">

      <h3>{{ t('statusProcessing') }}</h3>

      <h2>
        {{
          orders.filter(o => o.status === 'PROCESSING').length
        }}
      </h2>

      <span>{{ t('ordersInProgress') }}</span>

    </div>

    <!-- DONE -->
    <div class="summary-card done-card">

      <h3>{{ t('completed') }}</h3>

      <h2>
        {{
          orders.filter(o => o.status === 'DONE').length
        }}
      </h2>

      <span>{{ t('deliveredSuccessfully') }}</span>

    </div>

  </div>

  <!-- EMPTY -->
  <div
    *ngIf="orders.length === 0"
    class="empty"
  >

    {{ t('noOrdersFound') }}

  </div>

  <!-- ORDERS -->
  <div class="grid">

    <div
      *ngFor="let o of orders; trackBy: trackById"
      class="order-card"
    >

      <!-- TOP -->
      <div class="top">

        <div>

          <h3>
            {{ t('orderNumber') }} #{{ o.id }}
          </h3>

          <p class="customer">
            {{ t('customerOrder') }}
          </p>

          <p class="date">

            {{ o.createdAt | date:'medium' }}

          </p>

        </div>

        <span
          class="status-text {{o.status}}"
        >

          {{ statusLabel(o.status) }}

        </span>

      </div>

      <!-- BODY -->

<div class="body">
     
<div class="customer-info">

  <p>
    <strong>{{ t('nameLabel') }}:</strong>
    {{ o.name }}
  </p>

  <p>
    <strong>{{ t('phoneLabel') }}:</strong>
    {{ o.phone }}
  </p>

  <p>
    <strong>{{ t('addressLabel') }}:</strong>
    {{ o.address }}
  </p>

  <p *ngIf="mapLink(o)">
    <a
      class="map-link"
      [href]="mapLink(o)"
      target="_blank"
      rel="noopener"
    >
      <i class="fa-solid fa-map-location-dot"></i>
      {{ t('viewOnMap') }}
    </a>
  </p>

  <p>
    <strong>{{ t('paymentLabel') }}:</strong>
    {{ o.paymentMethod }}
  </p>

  <p>
    <strong>{{ t('emailLabel') }}:</strong>
    {{ o.userEmail }}
  </p>

</div>

    <div class="amount-grid">

  <div class="amount-box">
    <span>{{ t('totalAmountLabel') }}</span>
    <h2>৳ {{ o.totalAmount }}</h2>
  </div>

  <div class="amount-box">
    <span>{{ t('paidAmountLabel') }}</span>
    <h2 style="color:green">
      ৳ {{ o.paidAmount || o.totalAmount || 0 }}
    </h2>
  </div>

</div>

      </div>

      <!-- ACTIONS -->
     <div class="actions">

  <button
    class="toggle-btn"
    (click)="updateStatus(o)"
  >
    {{ t('updateStatus') }}
  </button>

  <button
    class="invoice-btn"
    (click)="openInvoice(o.id)"
  >
    📄 {{ t('invoice') }}
  </button>

  <button
  class="receipt-btn"
  (click)="openReceipt(o.id)"
>
  🧾 {{ t('receipt') }}
</button>

  <button
    class="delete-btn"
    (click)="delete(o.id)"
  >
    {{ t('delete') }}
  </button>

</div>

    </div>

  </div>

</div>
